import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { aesEncrypt, aesDecrypt, AES_ENABLE } from '@/utils/aes'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    // AES 加密请求参数
    if (AES_ENABLE && config.data) {
      const plainText = typeof config.data === 'string'
        ? config.data
        : JSON.stringify(config.data)
      config.data = { data: aesEncrypt(plainText) }
    } else if (!config.data) {
      if (AES_ENABLE) {
        config.data = { data: aesEncrypt('{}') }
      } else {
        config.data = {}
      }
    }

    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 防止 401 弹窗重复弹出
let isReloginShowing = false

function handleUnauthorized() {
  if (isReloginShowing) return
  isReloginShowing = true
  MessageBox.confirm('登录状态已过期，请重新登录', '登录超时', {
    confirmButtonText: '重新登录',
    cancelButtonText: '取消',
    type: 'warning'
  }).finally(() => {
    isReloginShowing = false
  }).then(() => {
    store.dispatch('user/resetToken').then(() => {
      location.reload()
    })
  }).catch(() => {})
}

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // AES 解密响应数据（data 字段为加密字符串时解密）
    if (AES_ENABLE && res.data && typeof res.data === 'string' && res.data.includes(':')) {
      try {
        const decrypted = aesDecrypt(res.data)
        res.data = JSON.parse(decrypted)
      } catch (e) {
        console.error('响应解密失败:', e)
      }
    }

    if (res.code !== 0) {
      if (res.code === 401) {
        handleUnauthorized()
        return Promise.reject(new Error(res.message || '未授权'))
      }

      Message({
        message: res.message || '操作失败',
        type: 'error',
        duration: 3000
      })
      return Promise.reject(new Error(res.message || '操作失败'))
    }

    return res
  },
  error => {
    // 处理 HTTP 层面的 401（兜底）
    if (error.response && error.response.status === 401) {
      handleUnauthorized()
      return Promise.reject(new Error('未授权，请重新登录'))
    }

    const message = error.response
      ? `请求失败 [${error.response.status}]: ${error.response.statusText}`
      : error.message
    Message({
      message,
      type: 'error',
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export default service
